/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-19 10:54:18
 **/

import { useLayoutEffect } from "react";
import { fromEvent } from "rxjs";

type Handler = () => void;

export default function useBeforeUnload(handler: Handler) {
	useLayoutEffect(() => {
		const subscrition = fromEvent(window, "beforeunload").subscribe(() => handler());
		return () => {
			subscrition?.unsubscribe();
		};
	}, [handler]);
}
